var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { createContext, useRef, useState } from "react";
import useServerSentEvents from "_shared/useServerSentEvents";
export const TopBarContext = createContext({});
export const TopBarProvider = ({
  value,
  children
}) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(value.isMaintenanceMode);
  const [areJobsRunning, setAreJobsRunning] = useState(value.areJobsRunning);
  const [runningJobs, setRunningJobs] = useState(value.runningJobs);
  const [queuedJobs, setQueuedJobs] = useState(value.queuedJobs);
  const queueEventTarget = useRef(new EventTarget());
  useServerSentEvents("maintenancemodeupdated", event => {
    setIsMaintenanceMode(event.detail.isMaintenanceMode);
    setAreJobsRunning(event.detail.areJobsRunning);
  });
  useServerSentEvents("queueupdated", event_0 => {
    setRunningJobs(event_0.detail.runningJobs);
    setQueuedJobs(event_0.detail.queuedJobs);
    if (event_0.detail.runningJobs.some(job => !runningJobs.some(j => j.id === job.id))) {
      queueEventTarget.current.dispatchEvent(new Event("newrunningjob"));
    }
    if (event_0.detail.queuedJobs.some(job_0 => !queuedJobs.some(j_0 => j_0.id === job_0.id))) {
      queueEventTarget.current.dispatchEvent(new Event("newqueuedjob"));
    }
  });
  return /* @__PURE__ */jsx(TopBarContext.Provider, {
    value: __spreadProps(__spreadValues({}, value), {
      isMaintenanceMode,
      areJobsRunning,
      runningJobs,
      queuedJobs,
      queueEventTarget
    }),
    children
  });
};